const questionnaireList = () => import('@/pages/questionnaire/index.vue');
const questionnaireForm = () => import('@/pages/questionnaire/form.vue');

export default [{
    path: '/questionnaire/list',
    component: questionnaireList,
    meta: [{
        name: '问卷配置'
    },
    {
        name: '问卷配置列表',
        activeRoute: '/questionnaire/list'
    }]
}, {
    path: '/questionnaire/form',
    component: questionnaireForm,
    meta: [{
        name: '问卷配置'
    },
    {
        name: '问卷配置列表',
        url: '/questionnaire/list',
    },
    {
        name: '添加/编辑',
        activeRoute: '/questionnaire/list'
    }]
}];